import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Form } from 'react-bootstrap'
import { Alert, message, Result } from 'antd'
import moment from 'moment'

import { publicStoreReferral } from '../Referrals/services'
import { publicStoreReferralOrder } from './services'
import { handleError } from '../../helpers'

import PublicSiteLayout from '../../layouts/PublicSiteLayout'
import ReferralsLimitCheckPoint from './partials/ReferralsLimitCheckPoint'
import ReferralOrderForm from './partials/ReferralOrderForm'

export default function ReferralPublicLink({ match }) {
    const { register, handleSubmit, formState: { errors }, setValue, watch } = useForm()
    const [loading, setLoading] = useState(false)
    const [canSend, setCanSend] = useState(false)
    const [success, setSuccess] = useState(false)
	const { employee_id } = match.params

    const onSubmit = values => {
        setLoading(true)
        values.expire_at = moment().add(1,'month').format('YYYY-MM-DD HH:mm:ss')
		publicStoreReferral({ 
			employee_id: employee_id,
			name: values.referral_name, 
			document: values.referral_document, 
			email: values.referral_email,
			mobile: values.referral_mobile,
		})
			.then(res => {
				publicStoreReferralOrder({
                    ...values, 
                    referral_id: res.data.data.id,
                    channel: 'stores',
                })
					.then(res => {
						message.success(res.data.message)
						setLoading(false)
						setSuccess(true)
					})
					.catch(error => {
						handleError(error)
						setLoading(false)
					})
			})
			.catch(handleError)
    }

    return <Alert message="No es posible enviar incentivos a referidos en este momento." type="warning" />

    if(success) return (
        <PublicSiteLayout>
            <Result
                status="success"
                title="¡Felicidades tu incentivo ha sido enviado a tu correo electrónico!"
                subTitle="Podrás redimirlo en cualquier tienda Spring."
            />
        </PublicSiteLayout>
    )

	return (
		<PublicSiteLayout>
			<div className='text-left mb-2 p-2 bg-light border'>
                Diligencia el formulario para recibir tu descuento exclusivo por ser referido de un colaborador Spring. Recibiras tu incentivo a tu correo electrónico y podrás redimirlo en cualquier tienda Spring.
            </div>
			<div className='text-left mb-3 p-2 bg-warning border'>
                En el momento de hacer efectivo este beneficio en cualquiera de nuestras tiendas, debes hacer la compra con la misma cédula que registres en este formulario
            </div>
            <ReferralsLimitCheckPoint
                employeeId={employee_id}
                canSend={canSend}
                setCanSend={setCanSend}
            />
			<Form onSubmit={handleSubmit(onSubmit)}>
                <ReferralOrderForm 
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    watch={watch}
                    disabled={!canSend}
                />
                <Button color="primary" type="submit" disabled={loading || !canSend}>
                    Solicitar mi incentivo
                </Button>
            </Form>
		</PublicSiteLayout>
	)
}